import api from "../api";

// --- Types ---
export type AppLink = {
  created_at: string;
  icon_image?: string; // <-- Add this line
  id: number;
  label: string;
  updated_at: string;
  updated_by: string;
  url: string;
};

export type RideOption = {
  capacity: number;
  description: string;
  estimated_time: any;
  estimatedTime: string;
  features: string[];
  id: string;
  image: string;
  image_path: string;
  image_url: string;
  price: number;
  title: string;
};

export async function addLink(link: {
  icon_image?: File; // <-- Use File type here
  icon_image_url?: string;
  label: string;
  url: string;
}): Promise<AppLink> {
  const formData = new FormData();
  formData.append("label", link.label);
  formData.append("url", link.url);
  if (link.icon_image) {
    formData.append("icon_image", link.icon_image);
  } else if (link.icon_image_url) {
    formData.append("icon_image_url", link.icon_image_url);
  }
  // If you need auth, set headers in api.ts

  const res = await api.post("/landing-page/links", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.link ?? res.data;
}

export async function addRideOption(
  ride: Omit<RideOption, "id">,
): Promise<RideOption> {
  const res = await api.post("/rides", ride);
  return res.data.ride;
}

export async function deleteLinks(id: string): Promise<void> {
  await api.delete(`/landing-page/links/${id}`);
}

export async function deleteRideOption(id: string): Promise<void> {
  await api.delete(`/rides/${id}`);
}

// --- Links ---
export async function fetchLinks(): Promise<AppLink[]> {
  const res = await api.get("/landing-page/links");
  return res.data.links;
}

// --- Ride Options (future) ---
export async function fetchRideOptions(): Promise<RideOption[]> {
  const res = await api.get("/ride-options"); // Adjust endpoint as needed

  if (res.data.success && res.data.ride_option) {
    return [res.data.ride_option];
  }
  if (Array.isArray(res.data.ride_options)) {
    return res.data.ride_options;
  }
  return [];
}

export async function updateLinks(links: AppLink[]): Promise<AppLink[]> {
  const res = await api.post("/landing-page/links/update", { links });
  return res.data.links ?? res.data;
}

export async function updateRideOption(ride: RideOption): Promise<RideOption> {
  const res = await api.put(`/rides/${ride.id}`, ride);
  return res.data.ride;
}
